module.exports = __webpack_public_path__ + "VIPV33.png?6201efe3bc7df6354454407bada4c08e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV33.png
// module id = 129
// module chunks = 0